module.exports = __webpack_public_path__ + "img/img_32.fba40fa2.png";